var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlienAbduction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 163,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.74 32.957c-10.256-1.637-21.936-2.51-34.1-2.51-11.132 0-21.857.73-31.456 2.107.003-.147.005-.295.011-.442C37.725 14.318 52.36.2 70.161.307c17.802.11 32.263 14.406 32.575 32.205.002.15.004.297.004.445z",
    fill: "#1D83EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.261.295a32.79 32.79 0 00-37.165 31.51c-.006.148-.009.295-.01.443 2.85-.41 5.804-.76 8.836-1.053.765-15.784 12.68-28.776 28.34-30.9z",
    opacity: 0.1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.08 35.557a132.027 132.027 0 00-14.344-3.045 207.54 207.54 0 00-23.923-2.299 249.394 249.394 0 00-18.262-.074c-7.816.23-15.612.89-23.356 1.973-5.732.79-11.408 1.94-16.995 3.445C7.174 39.16 0 43.985 0 49.147c0 5.16 7.174 9.988 20.2 13.59 9.161 2.533 20.456 4.26 32.763 5.052 5.08.33 10.331.498 15.677.498 5.364 0 10.633-.17 15.728-.5 11.2-.724 21.562-2.222 30.234-4.4a104.106 104.106 0 002.477-.651.215.215 0 01.036-.01l.576-.162c.383-.11.761-.217 1.133-.33l.049-.013c.323-.097.64-.193.954-.29.258-.082.513-.16.766-.242l.548-.178c.132-.044.262-.086.39-.13a35.704 35.704 0 00.734-.25c.165-.056.326-.113.486-.17l.52-.187a23.922 23.922 0 00.78-.29c.324-.122.64-.247.953-.37.156-.064.312-.126.466-.19a61.305 61.305 0 001.525-.651l.255-.116a36.858 36.858 0 00.84-.392c.828-.396 1.6-.8 2.317-1.214 4.5-2.577 6.873-5.434 6.873-8.404 0-5.162-7.174-9.988-20.2-13.59zm-.12 26.757c-9.17 2.536-20.497 4.263-32.836 5.049-5.019.319-10.206.484-15.484.484-5.26 0-10.43-.163-15.433-.482-12.36-.783-23.703-2.51-32.888-5.051C7.5 58.767.44 54.092.44 49.147c0-.437.055-.873.163-1.296 1.122-4.462 8.023-8.637 19.716-11.871a137.237 137.237 0 0116.865-3.426c7.79-1.09 15.634-1.75 23.496-1.98a251.053 251.053 0 0117.998.073 207.1 207.1 0 0124.062 2.31c4.792.745 9.54 1.754 14.22 3.023 11.692 3.234 18.59 7.407 19.715 11.866.11.425.165.862.165 1.3 0 4.946-7.06 9.621-19.88 13.168z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.155 49.347c0 2.94-2.423 5.72-6.748 8.204a35.808 35.808 0 01-2.974 1.522c-.06.029-.121.057-.183.084l-.255.116c-.112.049-.229.1-.343.152a60.483 60.483 0 01-1.182.5l-.466.189c-.312.123-.63.248-.953.37a23.924 23.924 0 01-.781.29l-.519.187c-.16.057-.321.114-.486.17l-.216.074c-.171.06-.345.119-.519.176-.127.044-.257.086-.39.13-.18.06-.362.118-.547.178-.253.081-.508.16-.766.242-.314.097-.631.193-.954.29-.016.005-.031.01-.049.013-.372.113-.75.22-1.133.33l-.576.161a162.855 162.855 0 01-2.512.662c-8.438 2.108-18.789 3.643-30.244 4.385-5.018.323-10.25.495-15.624.495-5.423 0-10.699-.174-15.757-.504C22.785 65.794.315 58.296.315 49.347A5.516 5.516 0 01.56 47.74c.013.037.026.072.042.11 3.14 8.245 25.419 14.91 54.327 16.535 4.428.25 9.015.38 13.71.38 4.715 0 9.32-.131 13.765-.382 28.884-1.633 51.142-8.299 54.27-16.538a4.67 4.67 0 00.139-.396c.223.608.338 1.25.34 1.897zM20.167 46.979c-3.661 0-7.553-.788-7.553-2.248 0-1.46 3.892-2.248 7.553-2.248 3.662 0 7.553.788 7.553 2.248 0 1.46-3.891 2.248-7.553 2.248zm0-4.056c-4.191 0-7.113.953-7.113 1.808 0 .855 2.922 1.808 7.113 1.808 4.192 0 7.113-.953 7.113-1.808 0-.855-2.921-1.808-7.113-1.808z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.787 57.319c-3.661 0-7.553-.788-7.553-2.248 0-1.46 3.892-2.248 7.553-2.248 3.662 0 7.553.788 7.553 2.248 0 1.46-3.891 2.248-7.553 2.248zm0-4.056c-4.191 0-7.113.953-7.113 1.808 0 .855 2.922 1.808 7.113 1.808 4.192 0 7.113-.953 7.113-1.808 0-.855-2.921-1.808-7.113-1.808zM116.967 46.979c-3.661 0-7.553-.788-7.553-2.248 0-1.46 3.892-2.248 7.553-2.248 3.662 0 7.553.788 7.553 2.248 0 1.46-3.891 2.248-7.553 2.248zm0-4.056c-4.191 0-7.113.953-7.113 1.808 0 .855 2.922 1.808 7.113 1.808 4.192 0 7.113-.953 7.113-1.808 0-.855-2.921-1.808-7.113-1.808zM101.347 57.319c-3.661 0-7.553-.788-7.553-2.248 0-1.46 3.892-2.248 7.553-2.248 3.662 0 7.553.788 7.553 2.248 0 1.46-3.891 2.248-7.553 2.248zm0-4.056c-4.191 0-7.113.953-7.113 1.808 0 .855 2.922 1.808 7.113 1.808 4.192 0 7.113-.953 7.113-1.808 0-.855-2.921-1.808-7.113-1.808zM68.567 62.159c-3.661 0-7.553-.788-7.553-2.248 0-1.46 3.892-2.248 7.553-2.248 3.662 0 7.553.788 7.553 2.248 0 1.46-3.891 2.248-7.553 2.248zm0-4.056c-4.191 0-7.113.953-7.113 1.808 0 .855 2.922 1.808 7.113 1.808 4.192 0 7.113-.953 7.113-1.808 0-.855-2.921-1.808-7.113-1.808z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F2E41",
    cx: 74.135,
    cy: 99.155,
    r: 9.243
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M66.122 107.48l4.498-2.253 1.257 2.511-4.498 2.253z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2F2E41",
    transform: "rotate(-56.601 66.019 108.448)",
    cx: 66.019,
    cy: 108.448,
    rx: 1,
    ry: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M76.393 107.739l1.257-2.511 4.498 2.253-1.257 2.51z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2F2E41",
    transform: "rotate(-33.399 82.251 108.448)",
    cx: 82.251,
    cy: 108.448,
    rx: 2.34,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 73.488,
    cy: 96.894,
    r: 3.159
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3F3D56",
    transform: "rotate(-45 73.51 95.542)",
    cx: 73.51,
    cy: 95.542,
    rx: 1.049,
    ry: 1.056
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.426 89.1c.14-3.422-2.81-6.32-6.587-6.474-3.777-.153-6.951 2.496-7.09 5.918-.139 3.422 2.486 4.2 6.263 4.353 3.777.153 7.275-.375 7.414-3.797z",
    fill: "#1D83EA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2F2E41",
    transform: "rotate(-40.645 83.744 100.488)",
    cx: 83.744,
    cy: 100.488,
    rx: 1.451,
    ry: 4.621
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2F2E41",
    transform: "rotate(-49.355 64.552 100.488)",
    cx: 64.552,
    cy: 100.488,
    rx: 4.621,
    ry: 1.451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.674 102.797a2.106 2.106 0 11-4.144.755v-.004c-.208-1.145.677-1.55 1.821-1.757 1.145-.207 2.115-.138 2.323 1.006z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.52 108.987a.44.44 0 01-.44-.44v-25.96a.44.44 0 11.88 0v25.96a.44.44 0 01-.44.44zM51.92 132.307a.44.44 0 01-.44-.44v-18.92a.44.44 0 01.88 0v18.92a.44.44 0 01-.44.44zM68.86 116.687a.44.44 0 01-.44-.44v-25.96a.44.44 0 11.88 0v25.96a.44.44 0 01-.44.44zM62.48 135.387a.44.44 0 01-.44-.44v-10.56a.44.44 0 01.88 0v10.56a.44.44 0 01-.44.44zM71.5 81.267a.44.44 0 01-.44-.44v-10.56a.44.44 0 11.88 0v10.56a.44.44 0 01-.44.44zM49.5 85.887a.44.44 0 01-.44-.44v-10.56a.44.44 0 11.88 0v10.56a.44.44 0 01-.44.44zM87.78 86.987a.44.44 0 01-.44-.44v-10.56a.44.44 0 11.88 0v10.56a.44.44 0 01-.44.44zM86.9 119.987a.44.44 0 01-.44-.44v-12.76a.44.44 0 01.88 0v12.76a.44.44 0 01-.44.44zM78.1 131.207a.44.44 0 01-.44-.44v-18.92a.44.44 0 01.88 0v18.92a.44.44 0 01-.44.44zM79.86 98.867a.44.44 0 01-.44-.44v-25.96a.44.44 0 11.88 0v25.96a.44.44 0 01-.44.44z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2F2E41",
    transform: "rotate(-39.938 130.761 150.476)",
    cx: 130.761,
    cy: 150.476,
    rx: 1.487,
    ry: 4.737
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F2E41",
    transform: "rotate(-71.565 120.684 148.83)",
    cx: 120.684,
    cy: 148.831,
    r: 9.475
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M121.816 156.266h2.878v5.157h-2.878zM116.059 156.266h2.878v5.157h-2.878z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2F2E41",
    cx: 122.295,
    cy: 161.484,
    rx: 2.399,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2F2E41",
    cx: 116.538,
    cy: 161.364,
    rx: 2.399,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.709 136.92c.846-3.407 4.58-5.412 8.34-4.478 3.762.934 6.124 4.453 5.278 7.86-.846 3.407-3.652 3.418-7.413 2.484-3.76-.933-7.051-2.458-6.205-5.866z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2F2E41",
    transform: "rotate(-64.626 110.012 144.434)",
    cx: 110.012,
    cy: 144.434,
    rx: 1.487,
    ry: 4.737
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 119.267,
    cy: 146.831,
    r: 3.159
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3D56",
    cx: 117.969,
    cy: 145.699,
    r: 1.053
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 119.24,
    cy: 153.427,
    r: 1.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.737 162.447h-51.92a.22.22 0 010-.44h51.92a.22.22 0 110 .44z",
    fill: "#3F3D56"
  }))));
}
export default SvgAlienAbduction;